export default "__VITE_ASSET__53db7227__"